import React, {Fragment} from 'react'
import { Link } from 'react-router-dom'

const BlockStyleEight = () => {
    return (
        <Fragment>
            <div className="block-style-eight mb-45 ps-xxl-5" data-aos="fade-up">
                <h6 className="sub-title-two mb-20">데이터 보호 솔루션</h6>
                <h3 className="sect-title mb-25">기업 데이터 자산을 안전하게 보호합니다</h3>
                <ul className="block-list list-none">
                    <li>개인정보 암호화 및 데이터 마스킹으로 민감 정보를 보호합니다.</li>
                    <li>ISMS, GDPR, PIPA 등 국내외 컴플라이언스 요건을 충족합니다.</li>
                    <li>재해 복구 계획(DRP) 및 백업 전략 수립으로 데이터 연속성을 보장합니다.</li>
                </ul>
                <Link className="theme_btn mt-35" to="/contact">자세히 알아보기</Link>
            </div>
        </Fragment>
    )
}

export default BlockStyleEight
